import { Font, HallmarkMembershipStatus, InitializationData } from '../../global-types';

export type Data = InitializationData;

//TODO: add the other things we may need or create a new state for the data as a whole
export type InitializationDataContextState = {
  initialized: boolean;
  fontFactor: number;
  defaultSize: number | null;
  defaultColor: string | null;
  fonts: Font[];
  hasFonts: boolean;
  data: Data | null;
  entryURL: string;
  lineItemUUID: string | null;
  isUS?: boolean;
  isUK?: boolean;
  isCE?: boolean;
  allRegions?: boolean;
  region?: string;
  membershipStatus: HallmarkMembershipStatus;
  //TODO: add colors
};

// Actions
// TODO: determine if we have other actions we may need based on the init data? Do we really need fonts here?
export enum actionTypes {
  SET_INIT_DATA = 'SET_INIT_DATA',
  UPDATE_FONT_STATE = 'UPDATE_FONT_STATE',
  SET_FONTS = 'SET_FONTS',
  RESET_DATA_CONTEXT = 'RESET_DATA_CONTEXT',
  SET_LINE_ITEM_UUID = 'SET_LINE_ITEM_UUID',
  UPDATE_PROJECT_NAME = 'UPDATE_PROJECT_NAME',
  SET_MEMBERSHIP_STATUS = 'SET_MEMBERSHIP_STATUS',
}

type SetFonts = {
  type: actionTypes.SET_FONTS;
  payload: Font[];
};

// TODO: can we set this as the init data or how do we want this to look?
type InitializationDataOptions = InitializationData | null;

export type UpdateOptions = {
  initialized?: boolean;
  fontFactor?: number;
  defaultSize?: number;
  defaultColor?: string;
  hasFonts?: boolean;
};

export type UpdateFontState = {
  type: actionTypes.UPDATE_FONT_STATE;
  payload: UpdateOptions;
};

type SetInitializationDataState = {
  type: actionTypes.SET_INIT_DATA;
  payload: InitializationDataOptions;
};

export type ResetDataContext = {
  type: actionTypes.RESET_DATA_CONTEXT;
};

export type SetLineItemUUID = {
  type: actionTypes.SET_LINE_ITEM_UUID;
  payload: string;
};

export type UpdateProjectName = {
  type: actionTypes.UPDATE_PROJECT_NAME;
  payload: string;
};

export type SetMembershipStatus = {
  type: actionTypes.SET_MEMBERSHIP_STATUS;
  payload: HallmarkMembershipStatus;
};

export type DataActions =
  | SetFonts
  | UpdateFontState
  | SetInitializationDataState
  | ResetDataContext
  | SetLineItemUUID
  | UpdateProjectName
  | SetMembershipStatus;

export type Dispatch = (action: DataActions) => void;

export type CreateContextProps =
  | { initializedDataState: InitializationDataContextState; initializationDataDispatch: Dispatch }
  | undefined;
